import React from 'react'

import "./Purchase.css"
import Split from './Split';

import { useTranslate } from "../Context/LanguageContext"
import Button from '../Util/Button';


const Purchase = () => {

    const t = useTranslate("purchase")

    return (
        <div className='purchase'>

            <section className='start'>

                <div className='wrapper'>
                    <div className='logo'>
                        <img
                            src="./images/logo3.svg"
                            alt="SINIS Logo"
                            decoding='async'
                        />
                        <p>SINIS</p>
                    </div>
                    <h1> {t("heading")} <span> China</span></h1>
                </div>

                <div className='img-wrapper'>
                    <img
                        src='./images/purchase.webp'
                        alt=""
                        loading='eager'
                        decoding='async'
                    />
                </div>

            </section>

            <section className='info'>

                <div className='img-wrapper'>
                    <img
                        src='./images/strategic-purchasing-in-china.webp'
                        alt=""
                        loading='lazy'
                        decoding='async'
                    />
                </div>

                <div className='wrapper'>
                    <p>{t("text1")}</p>
                    <p>{t("text2")}</p>
                    <p>{t("text3")}</p>
                    <Button to="/contact" filled>{t("contact")}</Button>
                </div>
            </section>

            <Split />

        </div>
    );
}

export default Purchase;